module.exports = __webpack_public_path__ + "37959575e1a03a0c39a69450d66f4d88.svg";